import { Organization } from '@core/models/organization';
import { QueryCache, QueryClient } from '@tanstack/react-query';
import { createIDBPersister } from '@utils/persister.utils';
import { Amplitude } from 'src/amplitude';

export const queryClient = new QueryClient({
  queryCache: new QueryCache({
    onSuccess: (data, query) => {
      if (query?.queryKey?.length && query.queryKey[0] === 'organization') {
        const org: Organization = { ...(data as Organization) };

        Amplitude.trackOrgSelected(org);
      }
    },
  }),
  defaultOptions: {
    queries: {
      cacheTime: 1000 * 60 * 60 * 24, // 24 hours
      staleTime: 1000 * 60 * 15, // 15 minutes
      retry: 0,
    },
  },
});

export const asyncPersister = createIDBPersister();
